// GET /api/feature_flags/:id	Get a feature flag
export const GET_FEATURE_FLAG = 'GET_FEATURE_FLAG'
export const GET_FEATURE_FLAG_FULFILLED = 'GET_FEATURE_FLAG_FULFILLED'
export const GET_FEATURE_FLAG_REJECTED = 'GET_FEATURE_FLAG_REJECTED'
export const getFeatureFlag = (payload) => ({ type: GET_FEATURE_FLAG, payload })
